<p-tieredMenu #tmenu 
    [model]="items"
    [popup]="true"
    [appendTo]="appendTo"
    [styleClass]="iconPosition() === 'left' ? 'icons-left' : ''">
    <ng-template pTemplate="submenuicon">
        <span class="p-submenu-icon"><kui-icon name="chevron-right"></kui-icon></span>
    </ng-template>
</p-tieredMenu>
